import { render, staticRenderFns } from "./cardPay.vue?vue&type=template&id=2bb92936&scoped=true&"
import script from "./cardPay.vue?vue&type=script&lang=js&"
export * from "./cardPay.vue?vue&type=script&lang=js&"
import style0 from "./cardPay.vue?vue&type=style&index=0&id=2bb92936&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb92936",
  null
  
)

export default component.exports